var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn accent_light",on:{"click":_vm.inviteDm}},[_c('span',[_vm._v("トークルームの招待を送る")])])}
var staticRenderFns = []

export { render, staticRenderFns }